import primaryApi from '@/utils/primaryApi'
let selfpackagename; // 包名
let uuId; // 用户id
let onlyid; // 乐园onlyid从底层参数中取，小游戏onlyid从用户信息中取
let baseParams; // 乐园环境下的底层参数
// 包名
if (primaryApi.isSource == "sg") { // 233小游戏
    selfpackagename = "com.meta.xyx";
} else { // 233乐园或非233
    selfpackagename = "com.meta.box";
}

// 确认uuid,onlyid
if (primaryApi.isSource) { // 233环境内
    let userInfo = JSON.parse(primaryApi.getUserInfo());
    uuId = primaryApi.isSource == "sg" ? userInfo.uuid : userInfo.uuId;
    onlyid = userInfo.onlyId;
}

// 获取乐园环境下的底层参数
if (primaryApi.isSource == "pd") { // 233乐园环境内
    baseParams = JSON.parse(primaryApi.getBaseParams());
    onlyid = baseParams.onlyId;
}

// 默认参数
Pandora.send("config", {
    "index_type": "wl", //web填 'wl'
    "selfpackagename": selfpackagename, //指定app包名
    "send_interval": 100, //发送间隔(ms)
    "debug": false,
    "uuId": uuId || "none",
    "onlyid": onlyid || "none", // 唯一 ID 
    "imei": baseParams ? baseParams.imei : "none", // Android 手机 IMEI
    "android_id": baseParams ? baseParams.android_id : "none",
    "device_name": baseParams ? baseParams.deviceName : "none", // 设备名称
    "oaid": "",
    "app_version_code": primaryApi.isSource ? primaryApi.getAppVersionCode() : "1", // 版本号
    "app_version_Name": primaryApi.isSource ? primaryApi.getAppVersionName() : "1.0", // 版本名称
    "channel_name": primaryApi.isSource ? primaryApi.getAppChannel() : "default", // 渠道-App名称
    "channel_package": selfpackagename, // App包名
    "sdk_version_code": "", // SDK版本号
});
// start命令必须发送
Pandora.send("start");

// 发起埋点
function pandoraSend(kind, params) {
    Pandora.send(kind, null, params);
}

const tea = {};
tea.install = (Vue) => {
    Vue.prototype.$tea = (kind, params) => pandoraSend(kind, params);
    Vue.$tea = (kind, params) => pandoraSend(kind, params);
};
  
export default tea;